import Image from 'next/image';
import React from 'react';
import styled from 'styled-components';
import { STRIPE_COUNTRIES } from '../../lib/stripe-countries';
import { COLORS } from '../../theme';
import { TidalButton } from '../common/button';
import FilterSelect from '../filters/FilterSelect';
import { Box } from '../Flex';
import { BackgroundButton } from '../Form';
import Loading from '../Loading';
import { analytics } from '../../lib/analytics';

const Container = styled.div`
  width: 100%;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 5px 36px #919db529;
  border: 2px solid #e1eaf3;
  border-radius: 15px;
  opacity: 1;
  @media only screen and (max-width: 1100px) {
    border: 1px solid #e5e8f0;
    box-shadow: 0 0;
  }
`;

const Contents = styled.div`
  padding: 1.5rem 2rem;
  @media only screen and (max-width: 500px) {
    padding: 16px;
  }
`;

const Title = styled.p`
  text-align: left;
  font: normal normal 600 16px/25px Poppins;
  letter-spacing: 0px;
  color: ${COLORS.BLACK};
  opacity: 1;
  margin: 0;
`;

const Subtitle = styled(Title)`
  color: ${COLORS.GRAY};
  opacity: 0.75;
  font-size: 14px;
  margin: 0;
`;

type SellerSettingsProps = {
  stripeSellerDashboardSSOLink?: string;
  stripeAccountId?: string;
  isStripeSellerAccountApproved: boolean;
  affiliateUrl: string;
  signUpForAffiliate: () => void;
  onboard: () => void;
  deleteAccount: () => void;
  loading: boolean;
  country: string;
  setCountry: (e: { label: string; value: string }) => void;
};

const SellerSettings = (props: SellerSettingsProps) => {
  const viewDashboard = () => {
    window.location.assign(props.stripeSellerDashboardSSOLink);
  };
  const onboard = () => {
    props.onboard();
  };
  const connectButton = props.loading ? (
    <Loading />
  ) : (
    // <img alt=""
    //   onClick={onboard}
    //   // @ts-ignore
    //   layout="fixed"
    //   width="190"
    //   height="33"
    //   src="/images/stripe-connect@2x.png"
    // />
    <TidalButton
      text="Connect"
      type="info"
      tint={false}
      onClick={onboard}
      Icon={<img alt="" src={'/images/stripe_transparent.png'} width={48} />}
      hasIcon={true}
    />
  );
  let content = (
    <>
      <Title>Become a Seller</Title>
      <Subtitle>Transferwise accepted through Stripe.</Subtitle>
      <Box height={5} />
      <FilterSelect
        options={STRIPE_COUNTRIES}
        value={props.country}
        onChange={props.setCountry}
      />
      <Box height={10} />
      {connectButton}
    </>
  );

  if (props.stripeAccountId && !props.isStripeSellerAccountApproved) {
    content = (
      <>
        <Title>Become a Seller</Title>
        <Subtitle>Finish Onboarding</Subtitle>
        <Box height={10} />
        {connectButton}
        <Box height={10} />
        <TidalButton
          text="Delete Stripe Account"
          onClick={props.deleteAccount}
          type="error"
          tint={false}
        />
      </>
    );
  }

  if (props.stripeSellerDashboardSSOLink) {
    content = (
      <>
        <Title>Seller Settings</Title>
        <Box height={10} />
        <TidalButton
          text="View Stripe Dashboard"
          onClick={viewDashboard}
          type="info"
          tint={false}
        />
        <Box height={10} width={20} />
        <TidalButton
          text="Delete Stripe Account"
          onClick={props.deleteAccount}
          type="error"
          tint={false}
        />
      </>
    );
  }

  let affiliateContent = null;

  const redirectToAffiliate = () => {
    analytics.track('User Clicked Affiliate Portal');
    window.location.replace(props.affiliateUrl);
  };

  const manageWebhooks = () => {
    analytics.track('User Clicked Affiliate Webhooks');
    window.location.replace('/dashboard/affiliate-webhooks');
  };

  if (props.affiliateUrl) {
    affiliateContent = (
      <>
        <Title>Affiliate Settings</Title>
        <Box height={10} />
        <TidalButton
          text="View Affiliate Portal"
          onClick={redirectToAffiliate}
          type="info"
          tint={false}
        />

        <Box height={10} />
        <TidalButton
          text="Manage Webhooks"
          onClick={manageWebhooks}
          type="info"
          tint={false}
        />
      </>
    );
  } else {
    affiliateContent = (
      <>
        <Title>Affiliate Settings</Title>
        <Box height={10} />

        <TidalButton
          text="Sign up as Affiliate"
          onClick={props.signUpForAffiliate}
          type="info"
          tint={false}
        />
        <Box height={10} />

        <TidalButton
          text="Manage Webhooks"
          onClick={manageWebhooks}
          type="info"
          tint={false}
        />
      </>
    );
  }

  return (
    <Container>
      <Contents>{content}</Contents>
      <div
        style={{ height: 1, width: '100%', backgroundColor: 'lightgray' }}
      ></div>
      <Contents>{affiliateContent}</Contents>
    </Container>
  );
};

export default SellerSettings;
